import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './gym/auth/AuthContext';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { notifyUpdateAvailable } from './gym/pwa/updateSignal';
import { reloadOnAcceptedUpdate } from './gym/pwa/reloadOnAcceptedUpdate';

// BrowserRouter > AuthProvider > App: the session lives only in the auth
// context (spec "Inicio y recuperación de sesión"); no Auth0 and no Redux in
// the new app's tree.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA (brief "PWA instalable HAMMER"): sólo en producción, nunca con
// `npm start`, para no servir contenido cacheado mientras se itera.
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({ onUpdate: notifyUpdateAvailable });

  // `clientsClaim()` (service-worker.js) also fires `controllerchange` on a
  // plain first install (no previous controller) — reloadOnAcceptedUpdate
  // only reloads if UpdateBanner actually marked the update as accepted
  // (fix round 1, review finding: otherwise every fresh visitor got an
  // unrequested reload).
  if ('serviceWorker' in navigator) {
    reloadOnAcceptedUpdate(navigator.serviceWorker);
  }
}
